// An email link (sign-up confirmation, password reset) that came back with an
// error — almost always "expired or already used". Before this the app landed
// silently on /welcome.
//
// Seen 2026-10-30: otp_expired on a confirmation link whose account turned
// out to be confirmed. The token is single-use: a second tap, or a mail
// provider's link scanner opening it first, uses it up, and signing in works.
// Hence the copy on SignInScreen.
//
// Read at import, like confirmedInBrowser.js: supabase-js may clear the hash
// during its (asynchronous) start-up.

const read = () => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const query = new URLSearchParams(window.location.search);
  const code = params.get('error_code') || query.get('error_code')
    || ((params.get('error') || query.get('error')) ? 'unknown' : null);
  return code;
};

let pending = read();

// Peek, not take: React may render (and StrictMode double-call) RootRedirect
// more than once. SignInScreen clears it once the message is up.
export function getAuthLinkError() {
  return pending;
}

export function clearAuthLinkError() {
  pending = null;
}
